import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Box, TextField } from "@mui/material";
import { useParams } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

import { isAdmin } from "../../../../../utils/constants";
import { updateBoard } from "../../../../../sevices/apiBoards";
import useToastPromise from "../../../../../hooks/useToast";
import { RFHTextField } from "../../../../../components/RFH";
import useBoardIdByKey from "../../../../../hooks/useBoardIdByKey";

function UpdateName({ boardName }) {
  const { id } = useBoardIdByKey();
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { showToastPromise } = useToastPromise();

  // React Hook Form
  const { register, handleSubmit, setValue, ...methods } =
    useForm({
      defaultValues: {
        board_name: boardName.data.responseData.board_name,
      },
    });

  useEffect(() => {
    setValue("board_name", boardName.data.responseData.board_name);
  }, [id]);

  const { mutate } = useMutation({
    mutationFn: async (data) => {
      return await showToastPromise(updateBoard, data);
    },
    onSuccess: (res) => {

      queryClient.invalidateQueries({
        queryKey: ["boards"],
        exact: true
      });
      queryClient.invalidateQueries({
        queryKey: ["boardName", id],
      });
      setLoading(false);
      //toast.success(res.data.message);
      //  handleCloseDialog();
    },
    onError: (error) => {
      console.error("Error Delete Attachments", error);
      //toast.error(error.response.data.message);
      setLoading(false);
      //  handleCloseDialog();
    },
  });

  const submit = (data) => {
    /**
     * Change Board Name
     */
    setOpen(false);
    if (data.board_name != boardName.data.responseData.board_name) {
      setLoading(true);
      mutate({ data, board_id: id });
    }
  };

  const openField = () => {
    if (boardName?.data?.responseData?.is_owner || isAdmin()) setOpen(true);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit(submit)();
    }
  };
  // console.log("getValues", formState);
  return (
    <>
      {open ? (
        <>
          <FormProvider {...methods}>
            <Box
              component="form"
              onSubmit={handleSubmit(submit)}
              noValidate
              className="board-field-name"
              onBlur={handleSubmit(submit)}
              onKeyDown={handleKeyDown}
            >
              <RFHTextField
                name="board_name"
                required
                fullWidth
                size="small"
                id="board_name"
                autoFocus
                defaultPadding={false}
              />
            </Box>
          </FormProvider>
        </>
      ) : (
        <p className="board-heading-name" onClick={openField}>
          {boardName?.data?.responseData?.board_name}
        </p>
      )}
    </>
  );
}

export default UpdateName;
